import { actionTypes } from '../const';

var initialState = {
  show:false,
  message:'',
  // shiftTime : '',
  // serverTime : '',
  showTimer : false,
  timerSecs : 0
};

const popupmessage = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.POPUP_MESSAGE:
      return Object.assign({}, state, {
        show: action.data.show,
        message: action.data.message
      });
    case actionTypes.POPUP_MESSAGE_CLOSE :
      return Object.assign({}, state, {
        show: action.data.show,
        message: action.data.message
      });
    // case actionTypes.GET_SHIFT_TIMING :
    //   return Object.assign({}, state, {
    //     shiftTime: action.shiftTime,
    //     serverTime: action.serverTime
    //   });
    case actionTypes.SHOW_LOGOUT_TIMER :
      return Object.assign({}, state, {
        showTimer: action.showTimer,
        timerSecs : action.timerSecs
      });
    case actionTypes.CLOSE_LOGOUT_TIMER :
      return Object.assign({}, state, {
        showTimer: action.showTimer,
        timerSecs : action.timerSecs
      });
    default:
      return state;
  }
};
export default popupmessage;